module.exports = __webpack_public_path__ + "img/Add role.8115e020.png";